import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import AuthShell from '../components/AuthShell';
import Toast from '../components/Toast';
import { OIDC_CALLBACK_PATH } from '../constants';

const COPY_TITLE = 'Finishing your sign-in';
const COPY_SUBTITLE = 'Your identity provider has confirmed you. Redirecting…';
const COPY_NO_PARAMS = 'Your identity provider did not return a sign-in result. Try signing in again.';

/**
 * Safety net only. In the BFF flow the IdP redirects straight to the
 * server callback (/v1/auth/oidc/callback) — the browser never lands
 * here. If an IdP is ever misconfigured to return to this SPA route,
 * forward the OAuth params (code + state) on to the canonical server
 * callback so the server-side code exchange + verification still runs.
 * This is NOT where tokens are handled — the SPA never sees one.
 */
export default function OidcReturn() {
  const location = useLocation();
  const search = location.search ?? '';
  const navigatedRef = useRef(false);

  useEffect(() => {
    if (search.length === 0 || navigatedRef.current) return;
    navigatedRef.current = true;
    window.location.assign(`${OIDC_CALLBACK_PATH}${search}`);
  }, [search]);

  if (search.length === 0) {
    return (
      <AuthShell title={COPY_TITLE} subtitle={COPY_SUBTITLE}>
        <Toast variant="error">{COPY_NO_PARAMS}</Toast>
      </AuthShell>
    );
  }

  return (
    <AuthShell title={COPY_TITLE} subtitle={COPY_SUBTITLE}>
      <div className="flex items-center gap-3" aria-live="polite">
        <span
          className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-brand-orange border-t-transparent"
          aria-hidden="true"
        />
        <span className="text-sm text-dark-secondary">Connecting…</span>
      </div>
    </AuthShell>
  );
}
